export default "__VITE_ASSET__29856792__"